import type { SelectorTypeToSelector } from '@carboncopyco/types';
import { v4 as uuid } from 'uuid';

export type DefaultArguments = {
  [key in keyof SelectorTypeToSelector]: Partial<
    SelectorTypeToSelector[key]['arguments']
  >;
};

// Default arguments per selector type.
const defaultArguments: Partial<DefaultArguments> = {
  text_content: {
    isCaseSensitive: false,
    isExactWord: true,
  },
};

export const createSelector = <T extends keyof SelectorTypeToSelector>(
  type: T,
  selectorArgs: Partial<SelectorTypeToSelector[T]['arguments']>
) => {
  return {
    id: uuid(),
    type,
    arguments: {
      ...defaultArguments[type],
      ...selectorArgs,
    },
  } as SelectorTypeToSelector[T];
};
